import { render } from "./basicCard.vue?vue&type=template&id=054beb5a"
import script from "./basicCard.vue?vue&type=script&lang=js"
export * from "./basicCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__